import { State } from 'modules';

export const requestSensitiveDataPending = (state: State) =>
  state.sensitiveData.requestSensitiveDataPending;
